export const extractFileNameFromContentDispositionHeader = (header: string | null): string => {
  if (!header) {
    return 'unknown';
  }

  const parts = header.split('filename=');
  if (parts.length == 2) {
    return JSON.parse(parts[1].trim());
  }

  return 'unknown';
};
